export interface CampaignEntryRule {
  label: string;
  sublabel: string;
  entries: string;
  bonus?: boolean;
}

export interface BrokerCampaign {
  enabled: boolean;
  /** ISO 8601. Replace with the real campaign end date before launch. */
  endsAt: string;
  eyebrow: string;
  badge: string;
  headlinePrefix: string;
  headlineHighlight: string;
  subcopy: string;
  prizeAmount: string;
  prizeLabel: string;
  backedByLabel: string;
  entryRules: CampaignEntryRule[];
}

export const brokerGiveaway: BrokerCampaign = {
  enabled: true,
  endsAt: '2026-08-31T23:59:00+10:00',
  eyebrow: 'Broker giveaway · Live now',
  badge: 'More entries, more chances to win',
  headlinePrefix: 'Win a ',
  headlineHighlight: '$200 Fuel Card',
  subcopy:
    "You're on the road all week chasing deals, so let us cover the tank. Rack up entries two ways, then we draw one winner when the campaign closes.",
  prizeAmount: '$200',
  prizeLabel: 'Fuel Card',
  backedByLabel: 'Backed by Authentik8',
  entryRules: [
    { label: 'Complete an inspection', sublabel: 'Automatic on completion', entries: '1 entry' },
    { label: 'Request lender access', sublabel: 'Per lender you request', entries: '+2 entries', bonus: true }
  ]
};

export const isCampaignActive = (c: BrokerCampaign, now: Date = new Date()): boolean => {
  const end = new Date(c.endsAt).getTime();
  if (Number.isNaN(end)) return false;
  return c.enabled && now.getTime() < end;
};
